import autoBind from "auto-bind";
import DataSourceModel from "src/core/data-sources/dataSourceModel";
import get from "lodash/get";

class ProductPricesRange extends DataSourceModel {
  constructor(priceRangeObject) {
    super();
    this.priceRangeObject = priceRangeObject;
    autoBind(this);
  }

  getMin() {
    return get(this.priceRangeObject, "attributes.min");
  }

  getMax() {
    return get(this.priceRangeObject, "attributes.max");
  }
}

export default ProductPricesRange;
